export const BRAND_ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_34fcbfc4-e526-415d-a5da-6caeeba668ab/artifacts/8luute8e_image.png",
  hero: "https://static.prod-images.emergentagent.com/jobs/34fcbfc4-e526-415d-a5da-6caeeba668ab/images/4904d75a39874a1426ecc9746020fa12fbc54ec4204417e3d54556aae8244c71.png",
  gallery: [
    "https://customer-assets.emergentagent.com/job_34fcbfc4-e526-415d-a5da-6caeeba668ab/artifacts/vusvs4yc_image.png",
    "https://customer-assets.emergentagent.com/job_34fcbfc4-e526-415d-a5da-6caeeba668ab/artifacts/ibtvfzee_image.png",
    "https://customer-assets.emergentagent.com/job_34fcbfc4-e526-415d-a5da-6caeeba668ab/artifacts/ik5kd24s_image.png"
  ]
};

export const HERO_HIGHLIGHTS = [
  { label: "Investimento mínimo", value: "R$ 2.500" },
  { label: "Modelo da operação", value: "Empresa real em atividade" },
  { label: "Condições", value: "Título individual" }
];

export const OPERATIONAL_PILLARS = [
  {
    title: "Fortalecimento operacional",
    description: "Ganho de fôlego para ampliar capacidade, padronização e atendimento de demanda recorrente."
  },
  {
    title: "Menor dependência de antecipação",
    description: "Redução do custo financeiro com antecipação de recebíveis e maior previsibilidade de caixa."
  },
  {
    title: "Estrutura para veículos elétricos",
    description: "Preparação da oficina para atender a nova demanda automotiva com serviços e equipamentos adequados."
  }
];

export const SECURITY_POINTS = [
  "Contrato formal",
  "Empresa real em operação",
  "Ativos como garantia",
  "Possibilidade de visita presencial",
  "Faturamento comprovado"
];

export const HOW_IT_WORKS = [
  {
    step: "01",
    title: "Você investe a partir de R$ 2.500",
    description: "Entrada acessível para participar da fase atual de expansão da operação."
  },
  {
    step: "02",
    title: "O valor é aplicado na operação da empresa",
    description: "O capital reforça a estrutura real da MM Service Car e o plano de crescimento, incluindo veículos elétricos."
  },
  {
    step: "03",
    title: "Você poderá receber retornos mensais conforme o desempenho da operação",
    description: "Você poderá receber retornos mensais conforme o desempenho da operação."
  }
];

export const TRUST_NUMBERS = [
  { label: "Empresa em operação", value: "Base real e ativa" },
  { label: "Possibilidade de visita", value: "Estrutura física disponível" },
  { label: "Transparência", value: "Condições no título individual" }
];